import {
    FETCH_MARKETS,
    FETCH_MARKETGOODS,
    FETCH_MARKETPURCHASES
} from '../actions/market';


export const initialState = {
    isFetching: true,
    data: null
};

export const markets = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MARKETS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_MARKETS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const marketGoods = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MARKETGOODS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_MARKETGOODS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const marketPurchases = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MARKETPURCHASES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_MARKETPURCHASES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/market.js